<nav id="side-menu" class="sidebar" >

  <ul class="nav flex-column">

    @for (item of menuItems; track item) {
      <li  class="nav-item">
        <a class="nav-link" [routerLink]="item.link"
          [attr.aria-expanded]="activeMenu === item.id"
          (click)="toggleDropdown(item.id)">
          <i class="{{ item.icon }}"></i>
          {{ item.name }}
            <i class="fa" [ngClass]="{
          'fa-chevron-down':  item.children && item.children.length > 0,
        }"></i>
        </a>
        @if (item.children &&item.children.length>0 &&activeMenu === item.id) {
          <ul
            class="nav flex-column childmenu">
            @for (child of item.children; track child) {
              <li class="nav-item" >
                <a  class="nav-link child-link"  [routerLink]="child.link">
                  <i class="{{ child.icon }}"></i>
                  {{ child.name }}
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }

  </ul>
</nav>
